<template>

<div class='jumbotron'>
  <h2>Hello, {{userEmail}}</h2>
  <h4>Your profile completion</h4>
  <br/>
  <div class='progress center-block' style='width:50%'>
  <div id="profile-progress" class='progress-bar progress-bar-striped' role='progressbar' style='width: 50%' aria-valuenow='50' aria-valuemin='0' aria-valuemax='100'>50%</div>
</div>
  <br/>



<div class='row'>
  <div class='col-sm-6'>

<div class='card'>
  <img class='card-img-top' src='../assets/imgcard2.png' style='width:100%'>  
  <div class='card-body'>
    <h2 class='card-title'><strong>Accout Data - </strong></h2>
        <hr>

    <h3 class='card-text text-center'>Enter and check out your basic data profile as name, surname, email, Ethereum and Lisk addresses. </h3>
      <br/>
      <router-link to='/Profile'><button id='myButton' class='btn btn-primary btn-md'>Show me</button></router-link>
  </div>
</div>

  </div>
  <div class='col-sm-6'>

<div class='card'>
  <img class='card-img-top' src='../assets/imgcard1.png' style='width:100%'>  
  <div class='card-body'>
    <h2 class='card-title'><strong>K.Y.C.</strong></h2>
<hr>
    <h4 id="messageKyc" class='card-text text-center'><img src="../assets/loading.gif" style="width:30px"></h4>
<h3><input v-on:keyup="checkName()" type="text" class="form-control" id="OLfirstName" placeholder="First Name"  required > &nbsp; <input v-on:keyup="checkName()" type="text"  placeholder="Last Name" class="form-control" id="OLlastName" required >
</h3>
          <br/>
    <button id='btn_grab' class='btn btn-primary btn-md' data-loading-text="<i class='fa fa-spinner fa-spin '></i> Loading ..." v-on:click='Grab'>Retreive Data</button>
    <button id='btn_start' class='btn btn-primary btn-md' data-loading-text="<i class='fa fa-spinner fa-spin '></i> Loading ..." v-on:click='StartKyc' disabled>Start Verification</button>

  <div id='risposta'></div>
  </div>
</div>

  </div>




</div>




</div>


</template>

<script>
import {xss} from "xss";

import crypto from "crypto";
import { stringify } from "querystring";

import firebase from "firebase";
import config from "./firebaseConfig";
let db = firebase.database();

var verifID;
var verifUrl;
var firstname, lastname;

//referenzio la tabella firebase

export default {
  name: "Home",
  data() {
    return {
      newKyc: {
        firstname: "",
        lastname: ""
      }
    };
  },

  computed: {
    userEmail() {
      return this.$store.state.storeEmail;
    },
    userId() {
      return this.$store.state.storeUid;
    }
  },

  mounted() {
    // Controllo se il Kyc è stato fatto per quello user

    var kycRef;
    let StoredUserId = this.$store.state.storeUid;
    //alert("User - : " + this.userId);
    kycRef = db.ref("kyc").child(StoredUserId);

    kycRef.once("value", function(snapshot) {
      if (snapshot.exists()) {
        if (snapshot.val().status == "started") {
          // QUI SE IL DATO è "STARTED VADO A CERCARE IN KYC-RESULTS IL RECORD CON VALORE VENDOR-ID UGUALE"
          // prima prendo il veriffId da questo dato
          $("#profile-progress").css("width", "75%");
          $("#profile-progress").text("75%");
          $("#btn_grab").css("visibility", "visible");
          $("#btn_start").css("visibility", "visible");
          $("#OLlastName").css("visibility", "visible");
          $("#OLfirstName").css("visibility", "visible");
          $("#messageKyc").html(
            "<h3><u>Your Kyc has started.</u><br/> Come back to this page in 10 minutes. If nothing changes you can launch the procedure again.<br/>Thank you!</h3>"
          );
          // --------------------------------------------

          var idVeriff = snapshot.val().verifId;
          let KycRefRESULTS_ref = db
            .ref("kyc-RESULTS")
            .child(idVeriff)
            .child("verification");
          KycRefRESULTS_ref.once("value", function(snapshotKYC) {
            if (snapshotKYC.exists()) {
              //alert(snapshotKYC.val().status);
              var realStatus = snapshotKYC.val().status;

              //=============================================
              //=========== ECCO QUI HO I VERI DATI =========
              //=============================================
              // gli stati possono essere:
              // approved, resubmission_requested, declined, expired, abandoned

              switch (realStatus) {
                case "approved":
                  $("#profile-progress").css("width", "100%");
                  $("#profile-progress").text("100%");
                  $("#btn_grab").css("visibility", "hidden");
                  $("#btn_start").css("visibility", "hidden");
                  $("#OLlastName").css("visibility", "hidden");
                  $("#OLfirstName").css("visibility", "hidden");
                  $("#messageKyc").html(
                    "<h3>Your Kyc data is completed!<br/>Please refer to this ETH address for the Ico:<br/>&rarr; <b>0x8396c13F59c2EEab0673034a8C101cebB9c93726</b></h3>"
                  );
                  break;

                case "resubmission_requested":
                  $("#profile-progress").css("width", "50%");
                  $("#profile-progress").text("50%");
                  $("#btn_grab").css("visibility", "visible");
                  $("#btn_start").css("visibility", "visible");
                  $("#OLlastName").css("visibility", "visible");
                  $("#OLfirstName").css("visibility", "visible");
                  $("#messageKyc").html(
                    "<h3><strong>Resubmission Requested! </strong> <br/>Something went wrong! <br/>Try Once again.</h3>"
                  );
                  break;

                case "abandoned":
                  $("#profile-progress").css("width", "50%");
                  $("#profile-progress").text("50%");
                  $("#btn_grab").css("visibility", "visible");
                  $("#btn_start").css("visibility", "visible");
                  $("#OLlastName").css("visibility", "visible");
                  $("#OLfirstName").css("visibility", "visible");
                  $("#messageKyc").html(
                    "<h3><strong>Kyc abandoned!</strong> <br/>Something went wrong! <br/>Try Once again.</h3>"
                  );
                  break;

                case "expired":
                  $("#profile-progress").css("width", "50%");
                  $("#profile-progress").text("50%");
                  $("#btn_grab").css("visibility", "visible");
                  $("#btn_start").css("visibility", "visible");
                  $("#OLlastName").css("visibility", "visible");
                  $("#OLfirstName").css("visibility", "visible");
                  $("#messageKyc").html(
                    "<h3><strong>Procedure expired!</strong> <br/>Something went wrong! <br/> Try Once again.</h3>"
                  );
                  break;

                case "declined":
                  $("#profile-progress").css("width", "50%");
                  $("#profile-progress").text("50%");
                  $("#btn_grab").css("visibility", "hidden");
                  $("#btn_start").css("visibility", "hidden");
                  $("#OLlastName").css("visibility", "hidden");
                  $("#OLfirstName").css("visibility", "hidden");
                  $("#messageKyc").html(
                    "<h3><strong>SORRY!</strong> <br/>Your Kyc has been declined! <br/>Please refer to our customer support.</h3>"
                  );
                  break;
              }
            }
          });
        }
      } else {
        // questo se non trova alcun Kyc inizializzato
        $("#profile-progress").css("width", "50%");
        $("#profile-progress").text("60%");
        $("#btn_grab").css("visibility", "visible");
        $("#btn_start").css("visibility", "visible");
        $("#OLlastName").css("visibility", "visible");
        $("#OLfirstName").css("visibility", "visible");
        $("#messageKyc").html(
          "<h3>Please follow our Kyc procedure <br/> <u>Sorry Safari browser not supported</u></h3>"
        );
      }
    });


   $(".btn").on("click", function() {
      var $this = $(this);
      $this.button("loading");
      setTimeout(function() {
        $this.button("reset");
      }, 2000);
    });


    
  },

  methods: {

    

    checkName: function() {
      //alert('ok');
       if(  ($("#OLfirstName").val()==='') || ($("#OLlastName").val()) === '' )  {
          $("#btn_start").prop("disabled", true);
       }
       else {
        $("#btn_start").prop("disabled", false);
       }
                
    },

    // Questo metodo fa partire il Kyc
    // richiedo con un POST a Veriff.me la sessionId sulla quale attivare il controllo

    StartKyc: async function() {
              //toastr.success("Your Lisk Address was successfully saved.");
              toastr.success('Your Kyc is starting.', 'Wait a moment..', {timeOut: 5000})


      try {
        const payload = {
          verification: {
            callback: "https://whitelist.brikbit.io/",

            person: {
              firstName: $("#OLfirstName").val(),
              lastName: $("#OLlastName").val()
            },

            lang: "it",
            features: ["selfid"],
            timestamp: timestamp(),
            vendorData: this.$store.state.storeUid
          }
        };

        const headers = {
          "x-auth-client": "677b8d35-b7b8-4c07-98a8-43fbc75e929c",
          "x-signature": generateSignature(
            payload,
            "497e397a-e66a-4db3-9aba-bdcbe8552f80"
          ),
          "content-type": "application/json"
        };

        const options = {
          method: "POST",
          headers: headers,
          body: JSON.stringify(payload)
        };


        const response = await fetch(
          "https://api.veriff.me/v1/sessions",
          options
        );
        const results = await response.json();
        console.log(results);

        // Scrivo i dati nella tabella Kyc
        //alert(results["verification"].id);
        verifID = results["verification"].id;
        verifUrl = results["verification"].url;
        await this.addKyc();

        // poi avvio il Kyc
      } catch (error) {
        console.log(error.message);
      }

      function timestamp() {
        return new Date().toISOString();
      }

      function generateSignature(payload, secret) {
        if (payload.constructor === Object) {
          payload = JSON.stringify(payload);
        }

        if (payload.constructor !== Buffer) {
          payload = Buffer.from(payload, "utf8");
        }
        const signature = crypto.createHash("sha256");
        signature.update(payload);
        signature.update(new Buffer(secret, "utf8"));
        return signature.digest("hex");
      }
    },

    addKyc: function() {
      //console.log("starting..");
      let KycRef = db.ref("kyc");
      let StoredUserId = this.$store.state.storeUid;

      // 'Scrivo i dati nel DB'
      KycRef.child(StoredUserId).set({
        email: this.$store.state.storeEmail,
        verifId: verifID,
        status: "started" // can be started / rejected / approved
      });

      // a questo punto lancio l'esecuzione del whitelist
      document.location.href = verifUrl;
    },

    Grab: function() {
      let db = firebase.database();
      var usersRef;

      let StoredUserId = this.$store.state.storeUid;
      //alert(this.userId);
      usersRef = db.ref("users").child(StoredUserId);

      // BINDO I DATI DI FIREBASE SULLA QUERY usersref
      // posso lanciare quasta azione da qui?
      usersRef.once("value", function(snapshot) {
        if (snapshot.exists()) {
          var content = "";
          //content += 'cazzo' + snapshot.val().name + ' - ' +  snapshot.val().surname + '';
          //console.log(content);
          $("#OLfirstName").val(snapshot.val().name);
          $("#OLlastName").val(snapshot.val().surname);
          $("#btn_start").prop("disabled", false);
          $("#btn_grab").prop("disabled", true);
        }
      });
    }
  }
};

</script>








<style>
.card {
  background-color: #fff;
  padding: 20px;
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  float: left;
}

.card-uncomplete {
  background-color: #f3f3f3;
  box-shadow: 0 0px 0px 0;
}

.card-complete {
  background-color: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.jumbotron {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue